module.exports = __webpack_public_path__ + "img/8_of_Spades.svg.9f65a829.png";